import React from 'react';
import { oneOfType, arrayOf, string, object } from 'prop-types';
/**
 * [NO VISUAL] Use the `JsonLD` component to insert SEO structured data inside script tag.
 */

const JsonLD = ({
  type,
  schema
}) => {
  const json = Array.isArray(schema) ? {
    '@context': 'https://schema.org/',
    '@graph': schema
  } : Object.assign({
    '@context': 'https://schema.org/',
    '@type': type
  }, schema);
  return /*#__PURE__*/React.createElement("script", {
    type: "application/ld+json",
    "data-testid": "jsonld-script",
    dangerouslySetInnerHTML: {
      __html: JSON.stringify(json)
    }
  });
};

process.env.NODE_ENV !== "production" ? JsonLD.propTypes = {
  type: string.isRequired,
  schema: oneOfType([arrayOf(object), object]).isRequired
} : void 0;
export default JsonLD;